enum TransferField {
  CORPS_ID,
  AMOUNT,
  BASE_CURRENCY,
  COMMENT,
  REMARKS
}
export default TransferField
